import auth0 from 'auth0-js';

interface Auth0Config {
    domain: string;
    clientId: string;
    redirectUri: string;
}

export class AuthZeroHelper {
    private authConfig: Auth0Config;

    constructor(config?: Partial<Auth0Config>) {
        this.authConfig = {
            domain: process.env.VUE_APP_AUTH0_DOMAIN as string,
            clientId: process.env.VUE_APP_AUTH0_CLIENT_ID as string,
            redirectUri: window.location.href,
            ...config,
        };
    }

    public async auth0COAuthenticate(
        email: string,
        password: string
    ): Promise<void> {
        const webAuthInstance = new auth0.WebAuth({
            domain: this.authConfig.domain,
            clientID: this.authConfig.clientId,
            audience: 'oanda',
            scope: 'openid profile email',
            redirectUri: this.authConfig.redirectUri,
        });
        const nonce = this.randomString(16);
        window.localStorage.setItem('nonce', nonce);

        const authenticating = (): Promise<void> => {
            return new Promise((resolve) => {
                webAuthInstance.crossOriginAuthentication.login(
                    {
                        username: email,
                        password: password,
                        realm: 'tms-users',
                        responseType: 'id_token',
                        nonce: nonce,
                        popup: true,
                        audience: 'oanda',
                    } as any,
                    () => {
                        resolve();
                    }
                );
            });
        };

        try {
            await authenticating();
        } catch (error) {
            throw error;
        }
    }

    public randomString(length: number) {
        const charset =
            '0123456789ABCDEFGHIJKLMNOPQRSTUVXYZabcdefghijklmnopqrstuvwxyz+/';
        let result = '';

        while (length > 0) {
            const bytes = new Uint8Array(16);
            const random = window.crypto.getRandomValues(bytes);

            random.forEach(function (c) {
                if (length == 0) {
                    return;
                }
                if (c < charset.length) {
                    result += charset[c];
                    length--;
                }
            });
        }
        return result;
    }
}
